import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import convertToSlug from '../../utils/convertToSlug';

const Categories: FC<{ cssPrefix: string; categories: string[]; version?: number }> = ({
    cssPrefix,
    categories,
    version,
}) => {
    if (version == 7)
        return (
            <section className={`${cssPrefix}-categories container`}>
                <div className={`${cssPrefix}-categories-container`}>
                    <h2 className={`${cssPrefix}-categories-header`}>Firmy według kategorii</h2>
                    <div className={`${cssPrefix}-categories-list`}>
                        {categories &&
                            categories.map((category) => (
                                <a
                                    key={category}
                                    href={`/firmy/${convertToSlug(category)}/`}
                                    className={`${cssPrefix}-categories-box box`}
                                >
                                    <div className="angleRight">
                                        <FontAwesomeIcon icon={faChevronRight} />
                                    </div>
                                    <h3>{category}</h3>
                                </a>
                            ))}
                    </div>
                </div>
            </section>
        );
    if (version == 6)
        return (
            <section className={`${cssPrefix}-categories`}>
                <div className={`${cssPrefix}-categories-container container`}>
                    <h2 className={`${cssPrefix}-categories-header`}>Firmy według kategorii</h2>
                    <div className={`${cssPrefix}-categories-list`}>
                        {categories &&
                            categories.map((category) => (
                                <a
                                    key={category}
                                    href={`/firmy/${convertToSlug(category)}/`}
                                    className={`${cssPrefix}-categories-box box`}
                                >
                                    <div className="angleRight">
                                        <FontAwesomeIcon icon={faChevronRight} />
                                    </div>
                                    <h4>{category}</h4>
                                </a>
                            ))}
                    </div>
                </div>
            </section>
        );
    if (version == 5)
        return (
            <section className={`${cssPrefix}-categories`}>
                <div className={`${cssPrefix}-categories-container container`}>
                    <h2 className={`${cssPrefix}-categories-header`}>Firmy według kategorii</h2>
                    <div className={`${cssPrefix}-categories-list`}>
                        {categories &&
                            categories.map((category) => (
                                <a
                                    key={category}
                                    href={`/firmy/${convertToSlug(category)}/`}
                                    className={`${cssPrefix}-categories-box box`}
                                >
                                    <h4>{category}</h4>
                                </a>
                            ))}
                    </div>
                </div>
            </section>
        );

    if (version == 4)
        return (
            <section className={`${cssPrefix}-categories`}>
                <div className={`${cssPrefix}-categories-container container`}>
                    <h2 className={`${cssPrefix}-categories-header`}>Firmy według kategorii</h2>
                    <div className={`${cssPrefix}-categories-list`}>
                        {categories &&
                            categories.map((category) => (
                                <a
                                    key={category}
                                    href={`/firmy/${convertToSlug(category)}/`}
                                    className={`${cssPrefix}-categories-box box`}
                                >
                                    <div className="angleRight">
                                        <FontAwesomeIcon icon={faChevronRight} />
                                    </div>
                                    <h4>{category}</h4>
                                </a>
                            ))}
                    </div>
                </div>
            </section>
        );

    if (version == 3)
        return (
            <section className={`${cssPrefix}-categories`}>
                <div className={`${cssPrefix}-categories-container container`}>
                    <h2 className={`${cssPrefix}-categories-header`}>Firmy według kategorii</h2>
                    <div className={`${cssPrefix}-categories-list`}>
                        {categories &&
                            categories.map((category) => (
                                <a
                                    key={category}
                                    href={`/firmy/${convertToSlug(category)}/`}
                                    className={`${cssPrefix}-categories-box box`}
                                >
                                    <h4>{category}</h4>
                                </a>
                            ))}
                    </div>
                </div>
            </section>
        );

    if (version == 2)
        return (
            <section className={`${cssPrefix}-categories`}>
                <div className={`${cssPrefix}-categories-container container`}>
                    <h2 className={`${cssPrefix}-categories-header`}>Firmy według kategorii</h2>
                    <div className={`${cssPrefix}-categories-list`}>
                        {categories &&
                            categories.map((category) => (
                                <a
                                    key={category}
                                    href={`/firmy/${convertToSlug(category)}/`}
                                    className={`${cssPrefix}-categories-box box`}
                                >
                                    <div className="angleRight">
                                        <FontAwesomeIcon icon={faChevronRight} />
                                    </div>
                                    <h3>{category}</h3>
                                </a>
                            ))}
                    </div>
                </div>
            </section>
        );

    return (
        <section className={`${cssPrefix}-categories`}>
            <div className={`${cssPrefix}-categories-container container`}>
                <h2 className={`${cssPrefix}-categories-header`}>Firmy według kategorii</h2>
                <div className={`${cssPrefix}-categories-list`}>
                    {categories &&
                        categories.map((category) => (
                            <a
                                key={category}
                                href={`/firmy/${convertToSlug(category)}/`}
                                className={`${cssPrefix}-categories-box box`}
                            >
                                <h3>{category}</h3>
                            </a>
                        ))}
                </div>
            </div>
        </section>
    );
};

export default Categories;
